import instance from '../common';

function getDimensionList() {
  return instance.get('/v1/dimensions');
}

function getSuggestList(dimension_name: string, keyword: string, limit = 100) {
  return instance.get('/v1/suggestion', {
    params: { dimension_name, keyword, limit },
  });
}

function getSimilarEvents(eventNames: string[]) {
  return instance.post('/v1/mapped_event/raw_events?src=trends', { event_names: eventNames });
}

export { getSuggestList, getDimensionList, getSimilarEvents };
